var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71,8.29l-.71-.29V3h-2v5l-.71,.29-1,1-.29,.71v2l.29,.71,1,1,.71,.29v7h2v-7l.71-.29,1-1,.29-.71v-2l-.29-.71-1-1Zm-.71,3.29l-.41,.41h-1.17l-.41-.41v-1.17l.41-.41h1.17l.41,.41v1.17Zm7.71,2.71l-.71-.29V3h-2V14l-.71,.29-1,1-.29,.71v2l.29,.71,1,1,.71,.29v1h2v-1l.71-.29,1-1,.29-.71v-2l-.29-.71-1-1Zm-.71,3.29l-.41,.41h-1.17l-.41-.41v-1.17l.41-.41h1.17l.41,.41v1.17ZM21.71,5.29l-1-1-.71-.29v-1h-2v1l-.71,.29-1,1-.29,.71v2l.29,.71,1,1,.71,.29v11h2V10l.71-.29,1-1,.29-.71v-2l-.29-.71Zm-1.71,2.29l-.41,.41h-1.17l-.41-.41v-1.17l.41-.41h1.17l.41,.41v1.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/1775031319/media/icon-settings.2da55bc48dcd4a81879a4f7b987cc66a.svg";
export { ForwardRef as ReactComponent };